import React from 'react';
import { FaMusic, FaVolumeDown } from 'react-icons/fa';
import { RiLoopRightFill } from 'react-icons/ri';
import { AudioType } from '../../../../dorian-shared/types/audio/audio';
import { BranchStep } from '../../../../dorian-shared/types/branch/BranchStep';
import { useLoopingAudioDetection } from '../BranchNodeCards/hooks/useLoopingAudioDetection';
import styles from './BranchItemBadge.module.scss';

type BranchItemBadgeProps = {
  steps: BranchStep[];
}

export function BranchItemBadge(props: BranchItemBadgeProps) {
  const { steps } = props;

  const isLoopingAudio = useLoopingAudioDetection(steps);

  const sfxCount = steps.filter((step) => step.stepAudios?.some((audio) => audio.type === AudioType.SFX)).length;
  const musicCount = steps.filter((step) => step.stepAudios?.some((audio) => audio.type === AudioType.Music)).length;
  const audioCount = sfxCount + musicCount;

  return (
    <div className={styles.container}>
      {audioCount > 0 && (
        <div className={styles.soundContainer}>
          {musicCount > 0 && (
            <div className={styles.musicItem} title={`Steps with music: ${musicCount}${isLoopingAudio ? ' (includes looping audio)' : ''}`}>
                {isLoopingAudio && (
                  <div
                    className={styles.loopingAudioBadge}
                    title="Node has looping audio"
                  >
                    <RiLoopRightFill size={18} />
                  </div>
                )}
              <FaMusic size={18} />
              <div className="ml-1">
                {musicCount}
              </div>
            </div>
          )}
          {sfxCount > 0 && (
            <div className={styles.sfxItem} title={`Steps with SFX: ${sfxCount}`}>
              <FaVolumeDown size={18} />
              <div className="ml-1">
                {sfxCount}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
